import React, { useState } from 'react';
import './../../entrydoor.css';

const FrameExtension = ({ value, onChange, label = 'Frame Extension:', childs = [] }) => { // Set default value for childs
    const [selectedFrameExtension, setSelectedFrameExtension] = useState(value || "");

    const visibleShapes = ['1"', '1 5/8"', '2"'];

    const handleFrameExtensionChange = (e) => {
        const newValue = e.target.value;
        setSelectedFrameExtension(newValue);
        onChange(e.target.value);

        // Dynamically fetch and modify styles for dependent controls if any exist
        if (Array.isArray(childs) && childs.length > 0) {
            childs.forEach((childId) => {
                const element = document.getElementById(childId);
                if (element) {
                    element.style.display = visibleShapes.includes(newValue) ? "block" : "none";
                    const label = element.previousElementSibling; // Fetch the label,block if present
                    if (label) {
                        label.style.display = visibleShapes.includes(newValue) ? "block" : "none";
                    }
                }
            });
        }
    };

    return (
        <div className="a-container">
            <label htmlFor="FrameExtension">{label}</label>
            <select
                id="FrameExtension"
                value={selectedFrameExtension}
                onChange={handleFrameExtensionChange}
            >
              <option value="" disabled hidden>Select an option</option>  
              <option value="None">{selectedFrameExtension === "None" ? "None ✔" : "None"}</option>
              <option value='5/8"'>{selectedFrameExtension === '5/8"' ? '5/8" ✔' : '5/8"'}</option>
              <option value='1"'>{selectedFrameExtension === '1"' ? '1" ✔' : '1"'}</option>
              <option value='1 5/8"'>{selectedFrameExtension === '1 5/8"' ? '1 5/8" ✔' : '1 5/8"'}</option>
              <option value='2"'>{selectedFrameExtension === '2"' ? '2" ✔' : '2"'}</option>
            </select>
        </div>
    );
};

export default FrameExtension;
